export const HumSupport = {
    NEW_TICKET: "https://info.humcapital.com/hum-help-center/kb-tickets/new",
};
